module.exports = __webpack_public_path__ + "img/logo_sorah.c3efecf4.png";